import React from 'react'
import InfoImage from "../../../Assets/Images/imgComparisonIllustrationBPN.jpg"

const HowWeCanHelp = () => {
    return (
        <section className='how-we-can-help-section'>
            <div className='container'>
                <div>
                    <h2 style={{ color: "#3a455a" }}><strong>How Do We Simplify Insurance Comparison and Purchase For You?</strong></h2>
                </div>
                <div>
                    <h3 style={{ color: "#fea44c" }}>By partnering with leading life and general insurance companies, we provide you with unparalleled access to the top insurance products on the market. Our advanced platform makes it easy to compare various options, ensuring you find the perfect fit for your needs with ease and efficiency.</h3>
                </div>

            </div>
            <div className='d-flex justify-content-center container'>
                <img className='' src={InfoImage} alt='info image' style={{width:"100%"}}/>
            </div>
        </section>
    )
}

export default HowWeCanHelp